import { emptyValidator, formValidator } from "../../validators";

const saveTemplateValidationStatus = {
  dyhCompany: {
    validators: [emptyValidator()],
    name: "Company is required",
  },
  dyhCategory: {
    validators: [emptyValidator()],
    name: "Category is required",
  },
  dyhInspectionType: {
    validators: [emptyValidator()],
    name: "Management Type is required",
  },
  dyhTemplate: {
    validators: [emptyValidator()],
    name: "Template Name is required",
  },
  dyhNextInspection: {
    validators: [emptyValidator()],
    name: "Next Inspection Value is required",
  },
  dyhNextUom: {
    validators: [emptyValidator()],
    name: "UOM is required",
  },
  dyhDescription: {
    validators: [emptyValidator()],
    name: "Description is required",
  },
  dyhStatus: {
    validators: [emptyValidator()],
    name: "Status is required",
  },
  dyhActive: {
    validators: [emptyValidator()],
    name: "Active is required",
  },
  dyhReportType: {
    validators: [emptyValidator()],
    name: "Report Type is required",
  },
};

export const dynamicTemplateCreationValidation = (templateDetails) => {
  return formValidator(templateDetails, saveTemplateValidationStatus);
};

const saveFieldsValidationStatus = {
  dyfField: {
    validators: [emptyValidator()],
    name: "Field Name is required",
  },
  dyfFieldType: {
    validators: [emptyValidator()],
    name: "Field Type is required",
  },
  dfyCommonDrodown: {
    validators: [emptyValidator()],
    name: "Common Dropdown is required",
  },
};

export const dynamicFieldCreationValidation = (fieldDetails) => {
  return formValidator(fieldDetails, saveFieldsValidationStatus);
};

const saveDropdownValuesValidationStatus = {
  dydValue: {
    validators: [emptyValidator()],
    name: "Dropdown Value is required",
  },
  dydDescription: {
    validators: [emptyValidator()],
    name: "Description is required",
  },
};

export const dynamicDropdownValuesCreationValidation = (dropdownDetails) => {
  return formValidator(dropdownDetails, saveDropdownValuesValidationStatus);
};
